import {
    UPDATE_PROFILE,
    UPDATE_SUBSCRIPTION_DATA,
    ACTIVE_SUBSCRIPTION
} from './profileTypes'

const teamState = {
    activeTeamId: undefined,
    activeTeam: undefined,
    user: '',
    type: '',
    isLoggedInUserOwner: false,
    firstTimeLoginGCSE : '',
    firstTimeLoginDN : '',
    firstTimeLoginAC : ''
};

const subscriptionState = {
    subscriptionData: undefined,
    isFreePlan: false,
    isTrialPlan: false,
    service_name: undefined,
}

const activeSubscriptionState = {
    activesubscription: undefined
}

export const profileReducer = (state = teamState, action) => {
    switch (action.type) {
        case UPDATE_PROFILE:
            return {
                ...state,
                activeTeamId: action.payload.activeTeamId || state.activeTeamId,
                activeTeam: action.payload.activeTeam || state.activeTeam ,
                user: action.payload.user ? action.payload.user : state.user,
                type: action.payload.type ? action.payload.user : state.type,
                isLoggedInUserOwner: action.payload.isLoggedInUserOwner,
                firstTimeLoginGCSE:action.payload.firstTimeLoginGCSE ? action.payload.firstTimeLoginGCSE : state.firstTimeLoginGCSE,
                firstTimeLoginDN:action.payload.firstTimeLoginDN ? action.payload.firstTimeLoginDN : state.firstTimeLoginDN,
                firstTimeLoginAC:action.payload.firstTimeLoginAC ? action.payload.firstTimeLoginAC : state.firstTimeLoginAC
            };
        default:
            return state;
    }
};


export const subscriptionReducer = (state = subscriptionState, action) => {
    switch (action.type) {
        case UPDATE_SUBSCRIPTION_DATA:
            // Handle both old format (with subscriptionData wrapper) and new format (direct payload)
            const subscriptionData = action.payload.subscriptionData || action.payload;
            
            // Extract service_name and determine isFreePlan
            let service_name = undefined;
            let isFreePlan = false;
            let isTrialPlan = false;
            
            if (subscriptionData) {
                // Find plan with service_name "AeroGCS Enterprise"
                let plan = null;
                
                // First, check in plans array
                if (subscriptionData.plans && Array.isArray(subscriptionData.plans)) {
                    plan = subscriptionData.plans.find(p => p.service_name === "AeroGCS Enterprise");
                }
                
                // If not found in plans, check addon object
                if (!plan && subscriptionData.addon && subscriptionData.addon.service_name === "AeroGCS Enterprise") {
                    plan = subscriptionData.addon;
                }
                
                // If still not found, fallback to first plan or addon
                if (!plan) {
                    plan = subscriptionData.plans?.[0] || subscriptionData.addon;
                }
                
                if (plan) {
                    // Extract service_name
                    service_name = plan.service_name;
                    
                    // Determine isFreePlan based on plan_type
                    // Free plans are those with plan_type "Trial" or "Free"
                    const planType = plan.plan_type;
                    isFreePlan = planType === "Free";
                    isTrialPlan = planType === "Trial";
                }
            }
            
            return {
                ...state,
                subscriptionData: subscriptionData,
                service_name: service_name,
                isFreePlan: isFreePlan,
                isTrialPlan: isTrialPlan
            };
        default:
            return state;
    }
};

export const activeSubscriptionReducer = ( state = activeSubscriptionState, action) => {
    switch (action.type) {
            case ACTIVE_SUBSCRIPTION:
                return {
                    ...state,
                    activesubscription : action.payload.activesubscription
                };
        default:
            return state;
    }

}
